<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-07-20 15:40:57
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-07-21 14:54:38
-->
<template>
	<div class="exportStateCell">
		<div class="flex flex-align-center">
			<div
				:class="['state_icon', row.task_status == '1' ? 'success' : row.success_count > 0 ? 'warning' : 'danger']"
				v-if="row[column.key] - 0"
			></div>
			<i class="el-icon-loading loading" v-else></i>
			<p class="ml-6 yx-color-text-primary" v-if="row.task_status === '1'">处理成功</p>
			<p class="ml-6 yx-color-text-primary" v-else-if="row.task_status === '0'">正在处理中...</p>
			<div class="ml-6 yx-color-text-primary" v-else-if="row.success_count > 0">
				<div><span>部分处理成功</span></div>
				<div>
					<span class="mr-8">成功</span>
					<span class="mr-20 yx-color-success">{{ row.success_count }}</span>
					<span class="mr-8">失败</span>
					<span class="yx-color-danger">{{ row.fail_count }}</span>
				</div>
			</div>
			<p class="ml-6 " v-else>处理失败</p>
		</div>
	</div>
</template>
<script>
import mixin from './mixin';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
.state_icon {
	width: 8px;
	height: 8px;
	border-radius: 50%;
}
.success {
	background-color: @color-success;
}
.danger {
	background-color: @color-danger;
}
.warning {
	background-color: @color-warning;
	margin-top: -25px;
}
.loading {
	color: @color-primary;
}
</style>
